import React from 'react';


function Terms() {
    return (
    <div>
        <>
        <p>
            <strong>Terms of Service Agreement for Critical Cases</strong>
        </p>
        <p>
            <strong>Effective Date:</strong>
            <span style={{ fontWeight: 400 }}> January 2025</span>
        </p>
        <p>&nbsp;</p>
        <p>
            <span style={{ fontWeight: 400 }}>
            This Terms of Service Agreement (“Agreement”) is a legally binding
            agreement between you (“User” or “you”) and M D Orbit LLC (“Company,”
            “we,” or “us”) regarding your access to and use of the
            </span>
            <strong> Critical Cases</strong>
            <span style={{ fontWeight: 400 }}>
            {" "}
            web application (“Service”). By purchasing or using the Service, you
            acknowledge that you have read, understood, and agree to be bound by this
            Agreement.
            </span>
        </p>
        <ol>
            <li>
            <strong> Software as a Service</strong>
            </li>
        </ol>
        <ul>
            <li>
            <span style={{ fontWeight: 400 }}>
                The Service is provided on a subscription basis as a Software as a
                Service (“SaaS”) product. Users are granted access to virtual simulated
                cases and associated study materials for the duration of their
                subscription.
            </span>
            </li>
            <li>
            <span style={{ fontWeight: 400 }}>
                The Service is provided “as is” and “as available,” with no guarantees,
                warranties, or representations regarding accuracy, completeness, or
                outcomes.
            </span>
            </li>
        </ul>
        <ol start={2}>
            <li>
            <strong> Not Affiliated with ABEM</strong>
            </li>
        </ol>
        <ul>
            <li>
            <span style={{ fontWeight: 400 }}>
                Critical Cases is not affiliated with or representative of the American
                Board of Emergency Medicine (ABEM) or any other medical certification
                organization. Any resemblance to other entities, cases, or materials is
                purely coincidental.
            </span>
            </li>
        </ul>
        <ol start={3}>
            <li>
            <strong> No Medical Advice or Patient Care Guidelines</strong>
            </li>
        </ol>
        <ul>
            <li>
            <span style={{ fontWeight: 400 }}>
                The content provided through the Service is strictly for informational,
                educational, and entertainment purposes.
            </span>
            </li>
            <li>
            <strong>
                The Service does not constitute medical advice, professional guidance,
                or patient care guidelines.
            </strong>
            <span style={{ fontWeight: 400 }}>
                {" "}
                No part of the Service is intended to replace professional judgment or
                real-life medical decision-making.
            </span>
            </li>
        </ul>
        <ol start={4}>
            <li>
            <strong> User Acknowledgements</strong>
            </li>
        </ol>
        <p>
            <span style={{ fontWeight: 400 }}>
            By purchasing or using the Service, you expressly acknowledge and agree to
            the following:
            </span>
        </p>
        <ul>
            <li>
            <span style={{ fontWeight: 400 }}>The Service is an </span>
            <strong>
                artistic and educational representation of virtual patients
            </strong>
            <span style={{ fontWeight: 400 }}> and is for </span>
            <strong>informational/pleasure purposes only</strong>
            <span style={{ fontWeight: 400 }}>.</span>
            </li>
            <li>
            <span style={{ fontWeight: 400 }}>The Service does not guarantee:</span>
            </li>
            <li>
            <span style={{ fontWeight: 400 }}>
                Improvement in your performance on the ABEM oral boards or any other
                certification exam.
            </span>
            </li>
            <li>
            <span style={{ fontWeight: 400 }}>
                Improved patient care skills or outcomes in real-life medical practice.
            </span>
            </li>
            <li>
            <span style={{ fontWeight: 400 }}>
                Any specific results, outcomes, or accuracy in the simulated cases.
            </span>
            </li>
        </ul>
        <ol start={5}>
            <li>
            <strong> Finality of Purchases</strong>
            </li>
        </ol>
        <ul>
            <li>
            <strong>All purchases are final.</strong>
            <span style={{ fontWeight: 400 }}>
                {" "}
                No refunds will be issued under any circumstances.
            </span>
            </li>
            <li>
            <span style={{ fontWeight: 400 }}>
                By subscribing to the Service, you are granted:
            </span>
            </li>
            <li>
            <span style={{ fontWeight: 400 }}>
                Access to all simulated cases for the duration of the subscription.
            </span>
            </li>
            <li>
            <span style={{ fontWeight: 400 }}>Three (3) attempts per case.</span>
            </li>
            <li>
            <span style={{ fontWeight: 400 }}>
                Access to study materials provided upon case completion.
            </span>
            </li>
        </ul>
        <ol start={6}>
            <li>
            <strong> Limitation of Liability</strong>
            </li>
        </ol>
        <ul>
            <li>
            <span style={{ fontWeight: 400 }}>
                To the fullest extent permitted by law, M D Orbit LLC shall not be held
                liable for any direct, indirect, incidental, consequential, or special
                damages arising out of or in connection with:
            </span>
            </li>
            <li>
            <span style={{ fontWeight: 400 }}>
                Your use of or inability to use the Service.
            </span>
            </li>
            <li>
            <span style={{ fontWeight: 400 }}>
                Any inaccuracies or errors in the information provided through the
                Service.
            </span>
            </li>
            <li>
            <span style={{ fontWeight: 400 }}>
                Any reliance you place on the content of the Service.
            </span>
            </li>
            <li>
            <strong>
                You assume all risks associated with the use of the Service, including
                but not limited to reliance on its accuracy or applicability.
            </strong>
            </li>
        </ul>
        <ol start={7}>
            <li>
            <strong> No Warranties</strong>
            </li>
        </ol>
        <ul>
            <li>
            <span style={{ fontWeight: 400 }}>
                The Service is provided “as is” without any warranties, express or
                implied, including but not limited to:
            </span>
            </li>
            <li>
            <span style={{ fontWeight: 400 }}>Fitness for a particular purpose.</span>
            </li>
            <li>
            <span style={{ fontWeight: 400 }}>Non-infringement.</span>
            </li>
            <li>
            <span style={{ fontWeight: 400 }}>Merchantability.</span>
            </li>
            <li>
            <span style={{ fontWeight: 400 }}>
                Accuracy, reliability, or availability.
            </span>
            </li>
        </ul>
        <ol start={8}>
            <li>
            <strong> Legal Protections</strong>
            </li>
        </ol>
        <ul>
            <li>
            <strong>No Claims or Trials:</strong>
            <span style={{ fontWeight: 400 }}>
                {" "}
                By agreeing to this Agreement, you waive your right to bring any claims,
                lawsuits, or legal disputes against M D Orbit LLC, its officers,
                employees, contractors, or affiliates.
            </span>
            </li>
            <li>
            <strong>Indemnification:</strong>
            <span style={{ fontWeight: 400 }}>
                {" "}
                You agree to indemnify and hold harmless M D Orbit LLC from any claims,
                damages, or expenses arising out of your use of the Service.
            </span>
            </li>
            <li>
            <strong>Binding Arbitration:</strong>
            <span style={{ fontWeight: 400 }}>
                {" "}
                Any disputes arising out of this Agreement shall be resolved exclusively
                through binding arbitration in the state of the Company’s principal
                place of business.
            </span>
            </li>
        </ul>
        <ol start={9}>
            <li>
            <strong> Intellectual Property</strong>
            </li>
        </ol>
        <ul>
            <li>
            <span style={{ fontWeight: 400 }}>
                All content, features, and functionality of the Service, including but
                not limited to text, graphics, logos, and software, are the exclusive
                property of M D Orbit LLC.
            </span>
            </li>
            <li>
            <span style={{ fontWeight: 400 }}>
                Unauthorized use, reproduction, or distribution of any part of the
                Service is strictly prohibited.
            </span>
            </li>
        </ul>
        <ol start={10}>
            <li>
            <strong> Privacy and Data Usage</strong>
            </li>
        </ol>
        <ul>
            <li>
            <span style={{ fontWeight: 400 }}>
                The Company may collect and use certain data as described in its Privacy
                Policy. By using the Service, you consent to the Company’s collection
                and use of your data as outlined in the Privacy Policy.
            </span>
            </li>
        </ul>
        <ol start={11}>
            <li>
            <strong> No Resemblance to Real Patients</strong>
            </li>
        </ol>
        <ul>
            <li>
            <span style={{ fontWeight: 400 }}>
                Any resemblance of simulated cases or materials to actual patients,
                cases, or scenarios is purely coincidental. The Service is entirely a
                product of creative representation.
            </span>
            </li>
        </ul>
        <ol start={12}>
            <li>
            <strong> Termination of Service</strong>
            </li>
        </ol>
        <ul>
            <li>
            <span style={{ fontWeight: 400 }}>
                The Company reserves the right to terminate or suspend your access to
                the Service at its sole discretion for any violation of this Agreement
                or other policies.
            </span>
            </li>
        </ul>
        <ol start={13}>
            <li>
            <strong> Governing Law</strong>
            </li>
        </ol>
        <ul>
            <li>
            <span style={{ fontWeight: 400 }}>
                This Agreement shall be governed by and construed in accordance with the
                laws of the state where M D Orbit LLC is incorporated, without regard to
                its conflict of law principles.
            </span>
            </li>
        </ul>
        <ol start={14}>
            <li>
            <strong> Entire Agreement</strong>
            </li>
        </ol>
        <ul>
            <li>
            <span style={{ fontWeight: 400 }}>
                This Agreement constitutes the entire agreement between you and M D
                Orbit LLC concerning the use of the Service and supersedes any prior
                agreements or understandings.
            </span>
            </li>
        </ul>
        <p>
            <strong>
            By purchasing the Service, you acknowledge that you have read, understood,
            and agreed to this Terms of Service Agreement.
            </strong>
            <span style={{ fontWeight: 400 }}>
            {" "}
            If you do not agree to these terms, you must not use or purchase the
            Service.
            </span>
        </p>
        <p>
            <span style={{ fontWeight: 400 }}>
            For any questions regarding this Agreement, please contact us at:
            </span>
        </p>
        <p>
            <strong>M D Orbit LLC</strong>
        </p>
        <p>
            <span style={{ fontWeight: 400 }}>Email: support@mdorbit.com</span>
        </p>
        <p>&nbsp;</p>
        </>

                {/* Privacy Policy */}
                <p><strong>Privacy Policy for Critical Cases</strong></p>
                <p>
                    <strong>Effective Date:</strong>
                    <span style={{ fontWeight: 400 }}> January 2025</span>
                </p>
                <p>&nbsp;</p>
                <p><span style={{ fontWeight: 400 }}>This Privacy Policy explains how M D Orbit LLC (“Company,” “we,” or “us”) collects, uses, stores, and protects your information when you access or use the Critical Cases web application (“Service”). By using the Service, you consent to the data practices described in this Privacy Policy.</span></p>
                <ol start={1}>
                    <li><strong>Information We Collect</strong></li>
                </ol>
                <ul>
                    <li><span style={{ fontWeight: 400 }}>Account Information: Your name, email address, and any other details provided during account registration or purchase.</span></li>
                    <li><span style={{ fontWeight: 400 }}>Payment Information: Payment details processed through secure third-party payment processors. We do not store credit card information.</span></li>
                    <li><span style={{ fontWeight: 400 }}>Usage Data: Information about your interactions with the Service, including accessed cases, attempt history, and time spent.</span></li>
                    <li><span style={{ fontWeight: 400 }}>Device & Technical Information: Browser type, IP address, device identifiers, and system logs for functionality and security.</span></li>
                </ul>
                <ol start={2}>
                    <li><strong>How We Use Your Information</strong></li>
                </ol>
                <ul>
                    <li><span style={{ fontWeight: 400 }}>To provide and maintain access to the Service.</span></li>
                    <li><span style={{ fontWeight: 400 }}>To manage subscriptions, case attempts, and study material access.</span></li>
                    <li><span style={{ fontWeight: 400 }}>To send important service-related notices and updates.</span></li>
                    <li><span style={{ fontWeight: 400 }}>To analyze usage patterns to improve case design, educational outcomes, and system functionality.</span></li>
                    <li><span style={{ fontWeight: 400 }}>To prevent fraud, enforce our Terms of Service, and protect our platform.</span></li>
                </ul>
                <ol start={3}>
                    <li><strong>Information Sharing</strong></li>
                </ol>
                <ul>
                    <li><span style={{ fontWeight: 400 }}>We do not sell or rent your personal data. We may share information with service providers or partners who help us deliver and support the Service (e.g., payment processing, analytics).</span></li>
                    <li><span style={{ fontWeight: 400 }}>If required by law, subpoena, or other legal process.</span></li>
                    <li><span style={{ fontWeight: 400 }}>In connection with a merger, sale, or acquisition, subject to standard confidentiality protections.</span></li>
                </ul>
                <ol start={4}>
                    <li><strong>Data Security</strong></li>
                </ol>
                <ul>
                    <li><span style={{ fontWeight: 400 }}>We implement industry-standard security measures to protect your information. While we strive to secure your data, no system can guarantee complete security.</span></li>
                </ul>
                <ol start={5}>
                    <li><strong>Data Retention</strong></li>
                </ol>
                <ul>
                    <li><span style={{ fontWeight: 400 }}>We retain your personal data only as long as necessary to provide you with access to the Service, comply with applicable laws, and resolve disputes or enforce our agreements. You may request deletion of your data by contacting us at support@mdorbit.com.</span></li>
                </ul>
                <ol start={6}>
                    <li><strong>Children’s Privacy</strong></li>
                </ol>
                <ul>
                    <li><span style={{ fontWeight: 400 }}>The Service is not intended for individuals under the age of 18. We do not knowingly collect or store information from children. If you believe a child has provided us information, please contact us.</span></li>
                </ul>
                <ol start={7}>
                    <li><strong>Your Rights</strong></li>
                </ol>
                <ul>
                    <li><span style={{ fontWeight: 400 }}>Depending on your location, you may have rights including access to or updating your personal information, requesting deletion of your account, and objecting to certain uses of your information. To exercise these rights, please email us at support@mdorbit.com.</span></li>
                </ul>
                <ol start={8}>
                    <li><strong>Changes to This Policy</strong></li>
                </ol>
                <ul>
                    <li><span style={{ fontWeight: 400 }}>We may update this Privacy Policy from time to time. Any changes will be posted on this page with the updated Effective Date. Continued use of the Service after such updates constitutes your acceptance of the revised policy.</span></li>
                </ul>
                <ol start={9}>
                    <li><strong>Contact Information</strong></li>
                </ol>
                <ul>
                    <li><span style={{ fontWeight: 400 }}>For any questions or concerns regarding this Privacy Policy, please contact us at support@mdorbit.com.</span></li>
                </ul>
           
    </div>
    );

}

export default Terms;